let vibe_cake_masters_targeted_landing_page = function( $ ) {

	let _init = function() {
		let add_to_cart_redirect_url = $( '#cake-masters-content' ).data( 'add-to-cart-redirect-url' );

		$( document.body ).on( 'masters-cart-module_added_to_cart_body masters-cart-course_added_to_cart_body', () => {
			if ( add_to_cart_redirect_url ) {
				window.location.href = add_to_cart_redirect_url;
			}
		} );
	}

	if ( $( '#cake-masters-content' ).hasClass( 'targeted-landing-page-content' ) ) {
		$( document ).ready(_init);
	}

} ( jQuery );

module.exports = vibe_cake_masters_targeted_landing_page;